import { createInitializeStoresFunction, createGetStoreFunction } from './helpers';
import { ObjectStore, RESERVED_OBJECT_METHODS } from '@utils/orm';
import _ from 'lodash-es';

export const CURRENT_USER_STORE_KEYS = {
  default: 'currentUserStore',
};

const CURRENT_USER_STORE_TYPES = {
  default: ObjectStore,
};

export const initializeCurrentUserStores = createInitializeStoresFunction(
  CURRENT_USER_STORE_KEYS,
  CURRENT_USER_STORE_TYPES
);

export const getCurrentUserStore = createGetStoreFunction(CURRENT_USER_STORE_KEYS, CURRENT_USER_STORE_TYPES);

export const cleanUserData = function (userData) {
  return _.omit(userData, RESERVED_OBJECT_METHODS);
};
